<div class="option" in:AnimIN out:AnimOUT class:picked on:click class:disabled={$profile.id === card.userId}>
    {char}
</div>

<style>
.option {
    font-size: 1.5em;
    padding: 1em 2em;
    border-radius: 50px;
    color: #fff;
    cursor: pointer;
    width: 30%;
    margin:0.5em auto;
    background: linear-gradient(0deg, var(--tera), var(--giga), var(--kilo), var(--mega));
    background-size: 100% 200%;
    box-shadow: 10px 10px 29px #d3801a;
    transition: background-position 200ms ease-in-out;
    background-position: 0% 0%;
}
.disabled {
    background: linear-gradient(0deg, var(--exa), var(--yetta));
}
.picked{
    background-position: 0 100%;
}
</style>

<script>
import { AnimIN, AnimOUT } from "../../../code/anim.js"

import { profile } from "../../../stores/profile"

export let card
export let char
export let picked
</script>